import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Wrapper from "../Helpers/Wrapper";
import useAlert from "../hooks/useAlert";

const Login = (props) => {
  const [showModal, setShow] = useState(false);
  // const [enteredPassword, setPassword] = useState("");
  const [enteredFirstName, setFirstName] = useState("");
  const [enteredLastName, setLastName] = useState("");
  const [memberNumber, setMemberNumber] = useState("");
  const { setAlert } = useAlert();

  const showModalHandler = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };
  const memberNumberChangeHandler = (event) => {
    setMemberNumber(event.target.value);
  };
  const firstNameChangeHandler = (event) => {
    setFirstName(event.target.value);
  };
  const lastNameChangeHandler = (event) => {
    setLastName(event.target.value);
  };
  // const passwordChangeHandler = (event) => {
  //   setPassword(event.target.value);
  // };

  const submitHandler = async (event) => {
    event.preventDefault();
    // console.log(enteredFirstName);
    // console.log(enteredLastName);
    // console.log(memberNumber);
    // console.log(enteredPassword);
    try {
      const rawResponse = await fetch("/mem-login.php", {
        method: "POST",
        body: JSON.stringify({
          fname: enteredFirstName,
          lname: enteredLastName,
          ...(memberNumber && { mem_num: memberNumber }),
          // ...(enteredPassword && { password: enteredPassword }),
        }),
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          // 'Access-Control-Allow-Origin': 'http://localhost:3000',
          "Access-Control-Allow-Credentials": "true",
        },
      });

      const content = await rawResponse.text();
      // console.log(`Got baclk from server: ${content}`);
      // console.log(`Got something of type ${typeof content}`);
      var jsonContent = JSON.parse(content);
      // console.log(`return after conversion is type ${typeof jsonContent}`);
      // console.log(`and it contains: ${jsonContent}`);
      // console.log(
      //   `And the object should be like: ${JSON.stringify(jsonContent)}`
      // );
      if (jsonContent.hasOwnProperty("error")) {
        console.error("Failed to login");
        setAlert('Something went wrong and we were not able to log you in. Please check your login information and try again.', 'error')
      } else {
        // console.log(`ID is ${jsonContent.id}`);
        // console.log(`accessType is ${jsonContent.accessType}`);
        // console.log(`fname is ${jsonContent.fname}`);
        props.handleLogin({
          id: jsonContent.id,
          accessType: jsonContent.accessType,
          fname: jsonContent.fname,
        });
      }
    } catch (e) {
      console.error(`Error ${e}`);
      setAlert(`Something went wrong and we were not able to log you in! Please check your login information and try again.`, 'error')
    } finally {
      handleClose();
    }
  };

  const makeButton = () => {
    if(props.variant === "link"){
    return (
      <a href="#" onClick={showModalHandler}>Login</a>  
    )
    }else if(props.variant === "success"){
      return (
        <Button className="shadow" variant="success" onClick={showModalHandler}>
        Login
      </Button>
      )
    }
  }

  return (
    <Wrapper>
      {/* <Button className={props.variant = "link" ? "shadow" : ""} variant={props.variant} onClick={showModalHandler}>
        Login
      </Button> */}
      {makeButton()}
      <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Use the form below to login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={submitHandler}>
            <input
              type="hidden"
              name="u"
              value="a06f27da732da8f233eb295cc"
            ></input>
            <input type="hidden" name="id" value="5dc57e0e3f"></input>
            <Form.Group className="mb-3">
              <Form.Text className="text-muted">
                All fields are mandatory.
              </Form.Text>
              <Form.Control
                type="name"
                placeholder="First name"
                name="fname"
                id="fname"
                onChange={firstNameChangeHandler}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Control
                type="name"
                placeholder="Last Name"
                name="lname"
                id="lname"
                onChange={lastNameChangeHandler}
                required
              />
            </Form.Group>
            {/* <Form.Text>AND: </Form.Text> */}
            <Form.Group className="mb-3">
              <Form.Control
                type="name"
                placeholder="MTNA/ASTA Member Number"
                name="mem_num"
                id="mem_num"
                onChange={memberNumberChangeHandler}
                required
              />
            </Form.Group>
            {/* <Form.Text>OR: </Form.Text> */}
            {/* <Form.Group className="mb-3">
              <Form.Control
                type="password"
                placeholder="Your Password"
                name="pwd"
                id="pwd"
                onChange={passwordChangeHandler}
              />
            </Form.Group> */}
            <Row className="justify-content-center">
              <Button variant="outline-primary" size="md" type="submit">
                Login
              </Button>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </Wrapper>
  );
};

export default Login;
